import { apiWrapper } from './helpers';
import { getGlobalState, STATE_KEYS } from '../configs/config_state';

export function getResourceCategories() {
    const truckData = getGlobalState(STATE_KEYS.TRUCK_DATA);
    const cityIDs = truckData.city?.map((item) => `city_id[]=${item.id}`).join('&') || 'city_id[]=17828';
    return apiWrapper(
        `/vendor/v2/resourceinformation/${truckData.id}?${cityIDs}`,
        'GET',
        'GET RESOURCE CATEGORIES'
    );
}
